<template>
  <div class="box-person-form">
    <div class="person-content">
      <div v-if="Object.keys(cardDetails).length > 0">
        <h3>{{ t.card_details }}</h3>
        <div class="person-form">
          <div>
            <label for="card-data">{{ t.card_number }}</label>
            <input type="text" :placeholder="'xxxx xxxx xxxx ' + cardDetails.last_four_digit" readonly>
          </div>
          <div>
            <label for="card-data">{{ t.card_brand }}</label>
            <input type="text" :placeholder="cardDetails.brand" readonly>
          </div>
          <div>
            <label for="card-data">{{ t.validity }}</label>
            <input type="text" :placeholder="cardDetails.due_month + '/' + cardDetails.due_year" readonly>
          </div>
        </div>
      </div>
      <h2 v-else>{{ t.no_card_details }}</h2>
    </div>
  </div>
</template>

<script>
export default  {
  name: 'card-component',
  props: {
    view: {
      type: Object|Array,
      required: true
    },
    translations: {
      type: Object|Array,
      required: true
    },
  },
  data() {
    return {
      cardDetails: null,
      t: null
    }
  },
  mounted() {
    this.cardDetails = JSON.parse(this.view[0].card_detail)
    this.t = this.translations
  }
}
</script>

<style scoped lang="scss">
.box-person-form{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.person-content{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
}
.person-content h3{
  padding-left: 1.8em;
}
.person-form{
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 1em 3em 3em;
  gap: 1.5rem;
  margin-bottom: 1rem;
}
.person-form div{
  display: flex;
  flex-direction: column;
}
.person-form div label{
  color: var(--primary-color) !important;
  font-weight: normal;
  margin-bottom: 0.7rem;
}
.person-form div input{
  background: #ffffff;
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  min-height: 42px;
  padding: 0.7rem;
  outline: none;
  transition: .5s;
  min-width: 250px;
  width: 25vw;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/invoices/CardComponent.vue